import { NewEnumTranslator as EnumTranslator } from '@skylab-shared/dataModel';

export enum PaymentSettlementKindInReport {
    AccountsReceivable = 'AccountsReceivable',
    AccountsPayable = 'AccountsPayable'
}

EnumTranslator.registerEnum(PaymentSettlementKindInReport, 'PaymentSettlementKindInReport');
